import { render } from "./CommentCount.vue?vue&type=template&id=d605398c"
import script from "./CommentCount.vue?vue&type=script&lang=js"
export * from "./CommentCount.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./CommentCount.vue?vue&type=style&index=0&id=d605398c&lang=module.scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__